import React, { useState, useMemo } from "react";
import { Row, Col } from "react-bootstrap";
import { GridColumn } from "@progress/kendo-react-grid";

import ErrorHandler from "components/core/ErrorHandler";

import SharedMainSelectableClientGrid from "shared/components/grids/clientGrid/SharedMainSelectableClientGrid";
import {
  DefaultColumnWidth,
  DefaultBooleanOrShortWidthColumnWidth,
} from "shared/components/grids/constants/KendoGridAndColumnConstants";
import useGridDataStateResetProcessing from "shared/hooks/useGridDataStateResetProcessing";

import ActivityAnalyticsForm from "./ActivityAnalyticsForm";
import ActivityAnalyticsDetailsModal from "./ActivityAnalyticsDetailsModal";

export default function ActivityAnalytics(props) {
  const [error, setError] = useState({});
  const [submittedFilters, setSubmittedFilters] = useState({});

  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  const {
    gridDataStateResetProcessingInitiated,
    InitiateGridDataStateReset,
    GridDataStateResetCompleted: onGridDataStateResetCompleted,
  } = useGridDataStateResetProcessing();

  const ViewDetailsActionCell = (cellProps) => {
    const hasLastLogin = !!(
      cellProps.dataItem && cellProps.dataItem.lastLoginDate
    );

    if (!hasLastLogin) {
      return <td className="noWrap" {...cellProps.style} />;
    }

    function viewDetailsClick() {
      setSelectedUser(cellProps.dataItem);
      setShowDetailsModal(true);
    }

    return (
      <td className="noWrap" {...cellProps.style}>
        <a
          onClick={viewDetailsClick}
          style={{
            cursor: "pointer",
            textDecoration: "underline",
            color: "#015CAB",
          }}
        >
          View Details
        </a>
      </td>
    );
  };

  const gridApiParams = useMemo(
    () => ({ rpid: submittedFilters.selectedParentCompany || "" }),
    [submittedFilters],
  );

  function handleFormSubmit(filters) {
    setError({});
    InitiateGridDataStateReset();
    setSubmittedFilters(filters);
  }

  function handleFormReset() {
    setError({});
    setSubmittedFilters({});
  }

  return (
    <div className="feature">
      <ErrorHandler error={error} onClose={() => setError({})} />

      <ActivityAnalyticsForm
        passedProps={props.passedProps}
        handleFormSubmit={handleFormSubmit}
        handleFormReset={handleFormReset}
      />

      <br />

      <Row>
        <Col className="tight-grid multi-line-filter">
          <SharedMainSelectableClientGrid
            apiGetEndpoint={"api/UserProgram/GetActivityAnalyticsUsers"}
            apiParameters={gridApiParams}
            exportFileNamePrefix={"ActivityAnalytics"}
            gridErrorHandlerCallback={setError}
            gridDataStateResetProcessingInitiated={
              gridDataStateResetProcessingInitiated
            }
            onGridDataStateResetCompleted={onGridDataStateResetCompleted}
            dateFormattingColumns={["lastLoginDate"]}
            styleOverride={{ height: "500px" }}
            pageSize={100}
          >
            <GridColumn
              field=""
              title="Action"
              filterable={false}
              sortable={false}
              groupable={false}
              cells={{ data: ViewDetailsActionCell }}
              width={DefaultColumnWidth()}
            />
            <GridColumn field="firstName" title="First Name" />
            <GridColumn field="lastName" title="Last Name" />
            <GridColumn field="contactEmail" title="Email" />
            <GridColumn field="contactType" title="Contact Type" />
            <GridColumn field="rpid" title="RPID" />
            <GridColumn field="ncpdp" title="NCPDP" />
            <GridColumn
              field="lastLoginDate"
              title="Last Login Date"
              filter="date"
              format="{0:d}"
            />
            {/* <GridColumn
              field="clientAnalyticsBlocked"
              title="Client Analytics Blocked"
              filter="boolean"
              width={DefaultBooleanOrShortWidthColumnWidth()}
            /> */}
          </SharedMainSelectableClientGrid>
        </Col>
      </Row>

      <ActivityAnalyticsDetailsModal
        show={showDetailsModal}
        user={selectedUser}
        onClose={() => {
          setShowDetailsModal(false);
        }}
      />
    </div>
  );
}
